<script setup>
import { onMounted } from 'vue';

onMounted(()=>{
  require('@/assets/js/simple-interest.js')
})
</script>
<template>
  <main class="seo-calculators simple-interest">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Simple Interest Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading fw-300">Simple Interest Calculator</h1>
      <h2 class="page-sub-heading">Calculate your simple interest.</h2>

      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Principal Amount</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalInvestments"
                        value="10000"
                        min="10000"
                        max="10000000"
                        step="1"
                        id="total-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="10000"
                    min="10000"
                    max="10000000"
                    step="1"
                    id="total-investment-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹1,00,00,000</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Number of years</h3>
                    <div class="slider__input">
                      <input
                        class="number-of-years"
                        type="number"
                        name="tenure"
                        value="5"
                        step="1"
                        min="1"
                        max="25"
                        id="tenure-input"
                      /><span class="m-l-4">yrs</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="1"
                    max="25"
                    id="tenure-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">1 yr</div>
                    <div class="slider__max">25 yrs</div>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Interest Rate</h3>
                    <div class="slider__input">
                      <input
                        class="number-of-years"
                        type="number"
                        name="expectedReturns"
                        value="10"
                        step="0.1"
                        min="1"
                        max="50"
                        id="expected-returns-input"
                      /><span class="m-l-4">%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="10"
                    step="0.1"
                    min="1"
                    max="50"
                    id="expected-returns-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">1%</div>
                    <div class="slider__max">50%</div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding">
            <aside class="calculator-output">
              <h3 class="calculator-output__heading">Principal Amount</h3>
              <div
                id="total-investment"
                class="calculator-output__amount--large"
              >
                ₹ 10,000
              </div>

              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Total Interest</h3>
                  <div id="est-amount" class="calculator-output__amount--small">
                    ₹ 5,000
                  </div>
                </div>
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Total Amount</h3>
                  <div
                    id="invested-amount"
                    class="calculator-output__amount--small"
                  >
                    ₹ 15,000
                  </div>
                </div>
              </div>
              <div class="calculator-output__chart-container">
                <canvas
                  id="mfChart"
                  width="200"
                  height="200"
                  style="
                    display: block;
                    box-sizing: border-box;
                    height: 200px;
                    width: 200px;
                  "
                ></canvas>
                <div class="calculator-output__chart-container--legend">
                  <div class="legend-title">
                    <span class="purple"></span>
                    <h3>Total Investment Amount</h3>
                  </div>
                  <div class="legend-title">
                    <span class="gold"></span>
                    <h3>Total Interest</h3>
                  </div>
                </div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is a simple interest calculator?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >Simple interest is the amount of money you make on your investment.
          It is also called the principal amount. For example, if you deposit or
          invest Rs.100 in a savings/investment option that pays simple interest
          at 7% per year, you will get Rs.7 every year as simple interest for
          the entire investment duration. At maturity, you will get back the
          initial investment amount, i.e. Rs.100 and interest generated at the
          end of the term. Calculating simple interest by hand over a long
          period may be tricky. A </span
        ><span style="font-weight: 400">simple interest rate calculator</span
        ><span style="font-weight: 400">
          is helpful in calculating the interest amount and accumulated amount
          over the required time frame.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400">A </span
        ><span style="font-weight: 400">simple interest calculator</span
        ><span style="font-weight: 400">
          is a digital tool that lets you calculate the amount of simple
          interest without taking too much time and doing </span
        ><span style="font-weight: 400">complicated calculations</span
        ><span style="font-weight: 400">. It has a </span
        ><span style="font-weight: 400">simple interest rate formula</span
        ><span style="font-weight: 400"> box already entered into the </span
        ><span style="font-weight: 400">online simple interest calculator</span
        ><span style="font-weight: 400"
          >. You have to simply enter the principal amount, interest rate, and
          time on the </span
        ><span style="font-weight: 400">simple interest calculator</span
        ><span style="font-weight: 400"> as per your requirements.</span>
      </p>
      <p>
        <span style="font-weight: 400">You can use Upstox’s </span
        ><span style="font-weight: 400">simple interest calculator online</span
        ><span style="font-weight: 400"
          >. You may use the simple interest calculator to figure out how much
          you’ll pay/earn at the end of a loan/investment if you are
          borrowing/investing money and paying/making simple interest.
        </span>
      </p>
      <p></p>
      <h2>What is simple interest rate formula?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >We may use simple interest in both investment and borrowing
          situations. With investment, you earn interest, but you must pay
          interest to the lender when you borrow money.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Let us see how simple interest would work in both of these
          cases.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >When you earn simple interest in your funds, the financial
          institution computes your interest income based on your invested
          amount. Here, the interest is generated only on the principal and not
          on the principal with interest earned previously. In case of simple
          interest, there is no such thing as interest on interest.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >So, in the above example, your yearly interest rate is 7% and is
          computed on the original investment amount of Rs.100. In the coming
          years, it will calculate interest based on 100, rather than the
          interest earned the prior year, i.e. Rs.7.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Compound interest varies from simple interest. The compound interest
          is computed on a larger sum each year. For example, if you invest
          Rs.100 and receive Rs.7 as the first year’s interest, you will collect
          interest on Rs.107 instead of Rs.100 next year. This makes simple
          interest rates different from compound interest.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >A Fixed Deposit with a monthly/quarterly payout option is an example
          of a saving option that offers simple interest. Here, the interest is
          earned on the principal only as the interest gained during the quarter
          or month is automatically credited to your savings account.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Car and consumer loans use simple interest to figure out the EMI. If
          we apply the previous example as before, but this time the 100
          represents the borrowed money rather than the invested amount, the
          interest due per year will be Rs.7.&nbsp;</span
        >
      </p>
      <p><b>Simple interest formula</b><b>&nbsp;</b></p>
      <p>
        <span style="font-weight: 400">Now, let us look at the </span
        ><span style="font-weight: 400">simple interest formula</span
        ><span style="font-weight: 400">.&nbsp;</span>
      </p>
      <p>
        <span style="font-weight: 400">Here’s the </span
        ><span style="font-weight: 400">simple interest rate formula</span
        ><span style="font-weight: 400">:&nbsp;</span>
      </p>
      <p>
        <b>Simple Interest</b
        ><span style="font-weight: 400"> = (P*R*T)/100</span>
      </p>
      <p><span style="font-weight: 400">Where:</span></p>
      <p>
        <b>P</b><span style="font-weight: 400">= Principa</span
        ><span style="font-weight: 400"
          >l (the original amount invested/borrowed)</span
        >
      </p>
      <p>
        <b>R</b
        ><span style="font-weight: 400"
          >= Interest rate (in per cent per annum)</span
        >
      </p>
      <p>
        <b>T</b><span style="font-weight: 400">= Time Duration (in years)</span>
      </p>
      <p>
        <span style="font-weight: 400">In this </span
        ><span style="font-weight: 400">simple interest formula</span
        ><span style="font-weight: 400"
          >, the annual interest rate is multiplied by the number of years and
          the principal amount.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400">Let us see an </span
        ><span style="font-weight: 400">example of</span>
        <span style="font-weight: 400">simple interest formula</span
        ><span style="font-weight: 400">.</span>
      </p>
      <p>
        <span style="font-weight: 400"
          >Let’s assume that the principal amount is Rs 1 lakh. The annual
          interest rate is 9%, and the term is two years.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Now the amount of simple interest will be</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Simple Interest = (1,00,000*9*2 years)/100</span
        >
      </p>
      <p>
        <span style="font-weight: 400">=1</span
        ><span style="font-weight: 400">8,000&nbsp;</span>
      </p>
      <p>
        <span style="font-weight: 400"
          >So, Rs.18,000 is the interest amount.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >To calculate the total amount that you will receive or must give at
          the end of two years will be&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Total amount = Principal + simple interest&nbsp;</span
        >
      </p>
      <p><span style="font-weight: 400">1,00,000+18,000 = 1,18,000</span></p>
      <p>
        <span style="font-weight: 400"
          >This helps to understand the amount received/paid at the end of the
          maturity period.&nbsp;</span
        >
      </p>
      <p><b>Future Value Calculation&nbsp;</b></p>
      <p>
        <span style="font-weight: 400">The above </span
        ><span style="font-weight: 400">simple interest formula</span
        ><span style="font-weight: 400">
          helps you figure out the interest amount on the principal.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >There is another formula that can show you the future
          amount.&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >To get the future amount with simple interest, we will need the
          principal, an interest rate and the time duration.&nbsp;</span
        >
      </p>
      <p><span style="font-weight: 400">Here’s the formula:&nbsp;</span></p>
      <p><b>FV= </b><span style="font-weight: 400">P(1+RT)</span></p>
      <p><span style="font-weight: 400">Where:</span></p>
      <p><b>FV</b><span style="font-weight: 400">= Future Value</span></p>
      <p><b>P</b><span style="font-weight: 400"> = Principal</span></p>
      <p>
        <b>R</b
        ><span style="font-weight: 400">
          = interest rate expressed as a decimal&nbsp;</span
        >
      </p>
      <p>
        <b>T</b
        ><span style="font-weight: 400">
          = number of time periods&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >Let’s calculate the future value with the </span
        ><span style="font-weight: 400">simple interest formula example</span
        ><span style="font-weight: 400"> that we mentioned above:&nbsp;</span>
      </p>
      <p>
        <span style="font-weight: 400"
          >FV = 1,00,000 (1+0.09*2) = Rs 1,18,000.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >We can see that the future value is the same for both calculators.
        </span>
      </p>
      <p></p>
      <h2>How does a simple interest calculator work?</h2>
      <p></p>
      <p>
        A simple interest calculator uses the formula that we have seen in the
        earlier paragraphs as part of its code. You enter all the variables for
        a specific loan or investment, and the calculator calculates the total
        interest you will earn or pay, depending on the information you provide.
      </p>
      <p>
        Imagine you wish to use a simple interest rate calculator online<span
          style="font-weight: 400"
        >
          to compute simple interest on your investment or loan. You can enter
          the principal amount (Rs.1 lakh), annual interest rate (7%) and five
          years.&nbsp;</span
        >
      </p>
      <p>
        Assuming that you have withdrawn no principal over the five years, the
        calculator will compute interest on the whole principal for the five
        years at 7% and calculate the interest as Rs.35,000 (i.e., Rs.1,000,000
        x 7% x 5 years).
      </p>
      <p>How to use Upstox’s Simple interest calculator</p>
      <p>
        The Upstox’s&nbsp;simple interest calculator is simple to use online. In
        order to use the Upstox Simple interest rate calculator, you need to
        input three things:
      </p>
      <p>
        1. The principal amount, i.e., the invested or borrowed amount<br />
        2. The simple interest rate<br />
        3. The time you will keep the money you have put in or the time the
        loan’s principal will be due
      </p>
      <p>
        After adding these values and hitting the calculate button, the online
        simple interest calculator will use the simple interest rate formula to
        calculate the interest amount and the total amount within seconds. You
        will get the actual interest you will get/pay throughout the period.
      </p>
      <p></p>
      <h2>What is the difference between the CI and SI calculator?</h2>
      <p></p>
      <p>
        In an earlier paragraph, you have seen that we calculate the interest on
        the principal amount in simple interest. However, the interest on
        interest is calculated to get the final amount with compound interest.
        So, in the case of compound interest, the principal on which you
        calculate the interest increases every year.
      </p>
      <p>
        Whether you earn simple or compound interest, it affects the overall
        amount of interest that you will accumulate. However, most investment
        options offer compound interest that allows you to receive interest on
        previous periods’ interest.
      </p>
      <p>
        Let’s understand the differences between simple interest and compound
        interest with the help of this table:
      </p>
      <table>
        <tbody>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Differentiating Point&nbsp;</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <b> Simple Interest</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Compound Interest</b>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Definition</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              Simple interest is calculated only on the principal amount of a
              loan, not on any interest from the previous loan period or
              deposit.
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <span style="font-weight: 400"
                >Compound interest is paid not only on the principal but also on
                the accumulated interest from the previous periods.</span
              >
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Interest paid&nbsp;</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <span style="font-weight: 400"
                >The amount is paid at the end of each period, i.e., in some
                cases, interest is paid at the end of each year on a regular
                basis.</span
              >
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              Compound interest is the case where interest is not paid at the
              end of every period. In fact, the interest earned is added to the
              principal amount. At maturity or redemption, the initial principal
              amount along with the accumulated interest is paid back to the
              individual.
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Interest Charged</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              Interest is paid on the principal only.
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <span style="font-weight: 400"
                >Interest is paid on the principal and accumulated interest as
                well.&nbsp;</span
              >
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Principal Amount</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <span style="font-weight: 400"
                >The principal amount is constant.</span
              >
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <span style="font-weight: 400"
                >The principal amount varies during the entire
                tenure.&nbsp;</span
              >
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 10px">
              <b>Formula</b>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <b>SI</b> = (P*R*T)/100
              <p></p>
              <p>Where:</p>
              <p><b>P</b>= Principal</p>
              <p>
                <b>R</b
                ><span style="font-weight: 400">= Interest rate&nbsp;</span>
              </p>
              <p>
                <b>T</b
                ><span style="font-weight: 400">= Time Duration&nbsp;</span>
              </p>
            </td>
            <td style="border: 1px solid #000; padding: 10px">
              <b>CI</b><span style="font-weight: 400">= [P x (1+R) N] – P</span>
              <p></p>
              <p><span style="font-weight: 400">Where:</span></p>
              <p>
                <b>P</b><span style="font-weight: 400">= Principal&nbsp;</span>
              </p>
              <p>
                <b>R</b
                ><span style="font-weight: 400">= Interest rate&nbsp;</span>
              </p>
              <p>
                <b>T</b><span style="font-weight: 400">= Time Duration</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <span style="font-weight: 400"
          >While in the short term, the difference in return between simple and
          compound rates of interest is negligible. Over the longer-term,
          compound interest offers remarkably better returns.</span
        >
      </p>
      <p></p>
      <h2>Benefits of a simple interest calculator</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >The simple interest calculation helps the borrower and lender make
          informed and calculated financial decisions. Following are the
          benefits of using a </span
        ><span style="font-weight: 400">simple interest calculator</span
        ><span style="font-weight: 400">:</span>
      </p>
      <ul>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400">A </span
          ><span style="font-weight: 400">simple interest calculator</span
          ><span style="font-weight: 400">
            calculates simple interest conveniently and without any
            errors.</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400"
            >You can figure out the simple interest on your investments or
            loans.&nbsp;</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400">You can use the </span
          ><span style="font-weight: 400">simple interest calculator</span
          ><span style="font-weight: 400">
            to calculate the interest irrespective of the currency. It works
            smoothly for other currencies, such as the dollar and euro, and
            computes values as per the different currencies. It is because the
            principal amount is taken as an absolute figure.&nbsp;</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400"
            >Simple interest benefits a borrower because the value of simple
            interest is lesser than compound interest.</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400">A </span
          ><span style="font-weight: 400">simple interest loan calculator</span
          ><span style="font-weight: 400">
            helps calculate the overall comparison between various borrowing
            options.
          </span>
        </li>
      </ul>
      <p></p>
      <h2>How Upstox is one of the best online Simple interest calculators?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >Following are the benefits of using Upstox’s </span
        ><span style="font-weight: 400">simple interest calculator</span
        ><span style="font-weight: 400">:</span>
      </p>
      <ul>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400">Online Simple interest calculator</span
          ><span style="font-weight: 400">
            is a free tool that displays the simple interest for the amount.
            Upstox </span
          ><span style="font-weight: 400">simple interest calculator</span
          ><span style="font-weight: 400">
            tool, makes the calculation faster, and it shows the results in a
            fraction of seconds.&nbsp;</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400"
            >Computing long calculations can get complicated. You can avoid
            manual errors by using Upstox </span
          ><span style="font-weight: 400"
            >online simple interest calculator</span
          ><span style="font-weight: 400">.&nbsp;</span>
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400"
            >You can compare your different investments or borrowing option
            provided by several financial institutions.&nbsp;</span
          >
        </li>
        <li style="font-weight: 400" aria-level="1">
          <span style="font-weight: 400">Upstox </span
          ><span style="font-weight: 400">simple interest calculator</span
          ><span style="font-weight: 400">
            is a web-based tool that is free to use.
          </span>
        </li>
      </ul>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How does a simple interest calculator work?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  <span style="font-weight: 400"
                    >You need to put the investment amount as the principal
                    amount, your expected rate of returns as the interest rate
                    and your suitable period for which you will invest your
                    money or loan period as the time.&nbsp;</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >By entering the needed details, you will get the interest
                    amount you will receive or pay on the principal amount. </span
                  ><span style="font-weight: 400">The </span
                  ><span style="font-weight: 400"
                    >online simple interest calculator</span
                  ><span style="font-weight: 400">
                    provides accurate results, free from any errors.&nbsp;</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >How do you calculate EMI in a simple interest loan
                    calculator?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  <span style="font-weight: 400">The </span
                  ><span style="font-weight: 400"
                    >simple interest loan EMI calculator</span
                  ><span style="font-weight: 400"> uses the </span
                  ><span style="font-weight: 400"
                    >simple interest EMI formula</span
                  ><span style="font-weight: 400">
                    to calculate the EMI.&nbsp;</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >Let us consider an example where the principal is Rs.
                    1,00,000, the interest rate is 9%, and the time is five
                    years.&nbsp;&nbsp;</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >Interest = (100000*9*5)/100</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400">Interest = Rs.45,000</span>
                </p>
                <p>
                  <span style="font-weight: 400"
                    >Total amount = Rs.1,45,000</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >EMI amount = Rs.1,45,000/12 = Rs.12083.3 per month
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is the Principal amount in SI calculators?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  <span style="font-weight: 400"
                    >The principal amount is the money that we have invested
                    initially or borrowed. Let us take an example regarding
                    investment.&nbsp;&nbsp;</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >You have received a Diwali bonus from the company of Rs
                    50,000, and you have invested that bonus in FD for one year
                    at an interest rate of 5% p.a. After one year, your 50,000
                    becomes Rs 52,500. In such a case, the principal amount will
                    be the amount you have invested originally, i.e., 50,000,
                    and the interest amount will be Rs 2,500.</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What is the rate of interest in simple interest
                    calculators?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  <span style="font-weight: 400"
                    >We can say that the interest rate is the cost of borrowing
                    the loan or the return on the investment option that uses
                    simple interest. For example, the interest rate offered on a
                    fixed deposit with quarterly/monthly withdrawal is 5%, then
                    5% is the simple interest you need to use when calculating
                    simple interest.&nbsp;</span
                  >
                </p>
                <p>
                  <span style="font-weight: 400"
                    >However, with car loans that use simple interest, the
                    annual interest of, say, 9% is the rate of interest that you
                    need to use when calculating simple interest on the </span
                  ><span style="font-weight: 400"
                    >simple interest calculator</span
                  ><span style="font-weight: 400">. </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Brokerage Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Margin Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Mutual Fund Returns Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> SIP Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> NPV Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Future Value Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> SWP Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> ELSS Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Option Value Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> NPS Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> PPF Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Compound Annual Growth Rate Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> National Savings Certificate Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Sukanya Samriddhi Yojana Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Compound Interest Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Atal Pension Yojana Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Gratuity calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Fixed Deposit Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> GST Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> HRA Calculator</a></h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
